export default {
  username: 'Benutzername',
  password: 'Passwort'
}



// WEBPACK FOOTER //
// ./src/lang/de/validations.js